module.exports = {
      id: "app-store-usage",
      viewBox: "0 0 144 48",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#app-store",
      toString: function () {
        return this.url;
      }
    }